import { Dispatch } from 'redux';
import {
    ReceiveRegisterUserAction,
    ReceiveRegisterUserWithErrorAction,
    REGISTER_USER,
    REGISTER_USER_ERROR,
    UserActionTypes,
} from '../types';
import { register } from '../../../services/UserAPI';
export function registerUser(
    name: string,
    email: string,
    password: string
): (dispatch: Dispatch<UserActionTypes>) => void {
    return async (dispatch: Dispatch<UserActionTypes>) => {
        try {
            const isLogged: boolean = await register(name, email, password);
            dispatch(receiveUserRegister(isLogged));
        } catch (error) {
            dispatch(receiveUserRegisterWithError(error));
        }
    };
}
const receiveUserRegister = (isLogged: boolean): ReceiveRegisterUserAction => {
    return {
        type: REGISTER_USER,
        isLogged: isLogged,
    };
};
const receiveUserRegisterWithError = (
    error: Error
): ReceiveRegisterUserWithErrorAction => {
    return {
        type: REGISTER_USER_ERROR,
        error: error,
    };
};
